module.exports = __webpack_public_path__ + "static/media/compliant-icon.1c661bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/compliant-icon.png
// module id = 95
// module chunks = 0